import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Alert } from 'react-bootstrap';

import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { LoginForm } from './loginform';
import { setUser } from '../../store/slices/userSlice'

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);

    const handleLogin = (email, password) => {
        const auth = getAuth();
        signInWithEmailAndPassword(auth, email, password)
            .then(({user}) => {
                dispatch(setUser({
                    email: user.email,
                    nickname: user.nickname,
                    id: user.uid,
                    token: user.accessToken,
                }));
                navigate('/admin');
            })
            .catch(() => {
                setShowAlert(true);
            })
    }

    return (
        <>
            {showAlert && (
                <Alert variant="danger" onClose={() => setShowAlert(false)} dismissible>
                    <span className='fs-6 regular'><i class="fa-regular fa-circle-xmark"></i> Yanlış email və ya parol</span>
                </Alert>
            )}

            <LoginForm
                title="Davam et"
                handleClick={handleLogin}
            />
        </>
    )
}

export {Login}